<div class="tw-bg-[#F8F9FB] tw-min-h-screen">
    <app-dashboard-wrapper>
        <h2 class="!tw-font-semibold">
            {{ "JC3.JC3_FEEDBACK_FORM" | translate }}
        </h2>
        <div class="lg:tw-flex tw-hidden tw-flex-col tw-gap-5">
            <button
                *ngIf="feedbacks?.length > 0"
                (click)="downloadInfo()"
                class="tw-bg-[#0A0A75] tw-flex tw-rounded-[30px] tw-py-[10px] tw-px-[20px] tw-items-center tw-gap-[10px] tw-text-white tw-font-semibold tw-text-base hover:tw-opacity-90 tw-ml-auto"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="tw-w-[24px] tw-h-[24px]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                {{ "JC3.DOWNLOAD_FORM_DETAILS" | translate }}
            </button>

            <div
                class="tw-bg-white tw-shadow-sm tw-rounded-[24px] tw-border tw-border-[#6D7A873D] tw-my-5"
            >
                <div class="">
                    <table
                        class="tw-min-w-full tw-divide-y tw-divide-[#E5E7EB]"
                    >
                        <thead class="tw-text-center">
                            <tr>
                                <th
                                    class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080]"
                                >
                                    {{ "JC3.NAME" | translate }}
                                </th>
                                <th
                                    class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080]"
                                >
                                    {{ "JC3.EMAIL" | translate }}
                                </th>
                                <th
                                    class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080]"
                                >
                                    {{
                                        "JC3.COMPANY_INSTITUTION_NAME"
                                            | translate
                                    }}
                                </th>
                                <th
                                    class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080]"
                                >
                                    {{ "JC3.TYPE_OF_INDUSTRY" | translate }}
                                </th>
                                <th
                                    class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080]"
                                >
                                    {{ "JC3.FEEDBACK_SUGGESTION" | translate }}
                                </th>
                                <th
                                    class="tw-py-[14px] tw-px-[14px] !tw-text-sm !tw-font-normal !tw-text-[#00000080]"
                                >
                                    {{ "JC3.DATE" | translate }}
                                </th>
                            </tr>
                        </thead>
                        <tbody
                            class="tw-text-sm tw-text-[#000000] tw-divide-y tw-divide-[#E5E7EB] tw-text-center"
                        >
                            <tr *ngFor="let item of feedbacks">
                                <td
                                    class="tw-py-4 tw-px-3 tw-text-[14px] tw-font-normal tw-max-w-[150px] tw-break-words"
                                >
                                    {{ item.name }}
                                </td>
                                <td
                                    class="tw-py-4 tw-px-3 tw-text-[14px] tw-font-normal tw-max-w-[150px] tw-break-words"
                                >
                                    {{ item?.email }}
                                </td>
                                <td
                                    class="tw-py-4 tw-px-3 tw-text-[14px] tw-font-normal tw-max-w-[150px] tw-break-words"
                                >
                                    {{ item.companyName }}
                                </td>
                                <td
                                    class="tw-py-4 tw-px-3 tw-text-[14px] tw-font-normal tw-max-w-[150px] tw-break-words"
                                >
                                    {{ item.typeOfIndustry }}
                                </td>
                                <td class="tw-py-4 tw-px-4 tw-text-[14px]">
                                    {{ item.feedback }}
                                </td>
                                <td class="tw-py-4 tw-px-4 tw-max-w-[150px]">
                                    {{
                                        item.createdAt
                                            | date : "dd MMM yyyy HH:mm:ss"
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <p
                *ngIf="feedbacks?.length == 0"
                class="!tw-text-sm !tw-text-center !tw-text-[#000000CC] !tw-font-semibold"
            >
                {{ "COMMON.NO_RECORD" | translate }}
            </p>
        </div>

        <!-- For Mobile -->
        <div
            class="tw-bg-white tw-rounded-[24px] tw-p-5 tw-shadow-lg tw-flex lg:tw-hidden tw-flex-col tw-items-center tw-gap-5"
        >
            <div *ngFor="let item of feedbacks">
                <div
                    class="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 tw-gap-x-[50px] tw-gap-y-3 tw-border-b tw-border-[#6D7A873D] tw-pb-2 tw-mb-2"
                >
                    <div class="tw-flex tw-flex-col tw-gap-1">
                        <span
                            class="!tw-text-sm !tw-font-normal !tw-text-[#00000080] tw-h-[40px]"
                            >{{ "JC3.NAME" | translate }}</span
                        >
                        <span
                            class="tw-text-[14px] tw-font-normal tw-min-h-[40px] tw-break-words"
                        >
                            {{ item.name }}
                        </span>
                    </div>
                    <div class="tw-flex tw-flex-col tw-gap-1">
                        <span
                            class="!tw-text-sm !tw-font-normal !tw-text-[#00000080] tw-h-[40px]"
                            >{{ "JC3.EMAIL" | translate }}</span
                        >
                        <span
                            class="tw-text-[14px] tw-font-normal tw-min-h-[40px] tw-break-words"
                        >
                            {{ item.email }}
                        </span>
                    </div>
                    <div class="tw-flex tw-flex-col tw-gap-1">
                        <span
                            class="!tw-text-sm !tw-font-normal !tw-text-[#00000080] tw-h-[40px]"
                            >{{
                                "JC3.COMPANY_INSTITUTION_NAME" | translate
                            }}</span
                        >
                        <span
                            class="tw-text-[14px] tw-font-normal tw-min-h-[40px] tw-break-words"
                        >
                            {{ item.companyName }}
                        </span>
                    </div>
                    <div class="tw-flex tw-flex-col tw-gap-1">
                        <span
                            class="!tw-text-sm !tw-font-normal !tw-text-[#00000080] tw-h-[40px]"
                            >{{ "JC3.TYPE_OF_INDUSTRY" | translate }}</span
                        >
                        <span
                            class="tw-text-[14px] tw-font-normal tw-min-h-[40px] tw-break-words"
                        >
                            {{ item.typeOfIndustry }}
                        </span>
                    </div>
                    <div class="tw-flex tw-flex-col tw-gap-1">
                        <span
                            class="!tw-text-sm !tw-font-normal !tw-text-[#00000080] tw-h-[40px]"
                            >{{ "JC3.FEEDBACK_SUGGESTION" | translate }}</span
                        >
                        <span
                            class="tw-text-[14px] tw-font-normal tw-min-h-[40px] tw-break-words"
                        >
                            {{ item.feedback }}
                        </span>
                    </div>
                    <div class="tw-flex tw-flex-col tw-gap-1">
                        <span
                            class="!tw-text-sm !tw-font-normal !tw-text-[#00000080] tw-h-[40px]"
                            >{{ "JC3.DATE" | translate }}</span
                        >
                        <span
                            class="tw-text-[14px] tw-font-normal tw-min-h-[40px] tw-break-words"
                        >
                            {{ item.createdAt | date : "dd MMM yyyy HH:mm:ss" }}
                        </span>
                    </div>
                </div>
            </div>
            <button
                *ngIf="feedbacks?.length > 0"
                (click)="downloadInfo()"
                class="tw-bg-[#0A0A75] tw-flex tw-rounded-[30px] tw-py-[10px] tw-px-[20px] tw-items-center tw-gap-[10px] tw-text-white tw-font-semibold tw-text-base hover:tw-opacity-90 tw-mx-auto"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="tw-w-[24px] tw-h-[24px]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                {{ "JC3.DOWNLOAD_FORM_DETAILS" | translate }}
            </button>
            <p
                *ngIf="feedbacks?.length == 0"
                class="!tw-text-sm !tw-text-center !tw-text-[#000000CC] !tw-font-semibold"
            >
                {{ "COMMON.NO_RECORD" | translate }}
            </p>
        </div>
    </app-dashboard-wrapper>
</div>
<app-loader [showLoader]="isLoading"></app-loader>
